import { useQuery } from '@tanstack/react-query';
import { getDependents, DependentsResponse } from '../services/configs-api';

/**
 * TanStack Query hook for fetching configurations that depend on a given configId.
 * Used by DeleteConfirmationModal and ConfigEditPage.
 */
export function useDependents(configId: string | undefined) {
  return useQuery<DependentsResponse>({
    queryKey: ['dependents', configId],
    queryFn: () => getDependents(configId!),
    enabled: !!configId,
    staleTime: 60_000,
  });
}
